import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Row, Col } from "reactstrap";
import { SET_USER_AND_PLAN_DETAILS } from "../../../actions/types";
import { useDispatch } from "react-redux";
import axiosInstance from "../../../axios-instance";
import UpdateCardModal from "./update-card-modal";

const ConfirmPaymentModal = (props) => {
  const dispatch = useDispatch();
  const [data,                setData]                = useState(null);
  const [prorateLoading,      setProrateLoading]      = useState(false);
  const [prorateError,        setProrateError]        = useState("");
  const [isOpen,              setIsOpen]              = useState(false);
  const [showChangeCardModal, setShowChangeCardModal] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    setProrateLoading(true);
    setProrateError("");
    setData(null);

    axiosInstance
      .get(`/admin/get-prorated-charges/${props.plan_id}/${props.planPeriodType}`)
      .then((res) => {
        if (res.data.success) {
          setData(res.data);
        } else {
          setProrateError("Could not load billing preview. You can still proceed.");
        }
      })
      .catch(() => {
        setProrateError("Could not load billing preview. You can still proceed.");
      })
      .finally(() => {
        setProrateLoading(false);
      });
  }, [isOpen]);

  /**
   * on toggle modal
   */
  const toggle = () => {
    setIsOpen((prevState) => !prevState);
  };

  const { plan, userCurrentPlan, planPeriodType } = props;
  return (
    <>
      <button
        button
        className="btn btn-outline brand"
        onClick={(event) => {
          event.preventDefault();
          dispatch({
            type: SET_USER_AND_PLAN_DETAILS,
            payload: {
              selectedPlan: plan,
            },
          });
          toggle();
        }}
      >
        {
          ((planPeriodType === "monthly" && plan.monthly_price > userCurrentPlan.monthly_price) ||
          (planPeriodType === "annual" && plan.annual_price > userCurrentPlan.annual_price))
          ? "Upgrade Plan"
          : "Downgrade Plan"
        }
      </button>

      {showChangeCardModal && <UpdateCardModal toggle={setShowChangeCardModal}/>}
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalBody>
          <div className="">
            <div className="eventdetailsaddbox rd_modalvieew">
              <div className="box_content rd_modalboxcontent">
                <div className="rd_inputselectheadermodalsetting">
                  <button className="rd_colsebtn" onClick={toggle}></button>
                </div>

                <p className="rd_modalheadertextparath mt-5 mb-5">
                  Are you sure you want to{" "}
                  {userCurrentPlan.monthly_price > plan.monthly_price
                    ? "downgrade"
                    : "upgrade"}{" "}
                  your subscription plan?
                </p>

                {/* ── Billing preview ── */}
                {prorateLoading ? (
                  <p className="rd_modalheadertextparath mt-3 mb-3" style={{ color: "#9CA3AF" }}>
                    Loading billing preview…
                  </p>
                ) : prorateError ? (
                  <p className="rd_modalheadertextparath mt-3 mb-3" style={{ color: "#EF4444", fontSize: "13px" }}>
                    {prorateError}
                  </p>
                ) : data ? (
                  <>
                    <p className="rd_modalheadertextparath mt-3 mb-3">
                      Starting{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>
                        {data.next_billing_date}
                      </span>
                      {" "}your {props.planPeriodType === "monthly" ? "monthly" : "annual"} bill
                      will be{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>
                        ${data.new_monthly_amount}
                      </span>
                    </p>

                    <p className="rd_modalheadertextparath mt-3 mb-3">
                      An estimated prorated charge of{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>${data.prorated_amount}</span>{" "}
                      will be applied on your{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700", textTransform: "capitalize" }}>{data.card_brand}</span>{" "}
                      ending with{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>{data.card_last_four}</span>.
                    </p>
                  </>
                ) : null}

                <Row className="mb-3">
                  <Col className="text-center">
                    <button className="btn btn_success btn-sm" onClick={() => setShowChangeCardModal(true)}>Change Card</button>
                  </Col>
                </Row>
                

                <div className="rd_cancelappbtnmodal">
                  <button className="btn btn-danger" onClick={toggle}>
                    Cancel
                  </button>
                  <button
                    className="btn btn-app"
                    onClick={() => {
                      props.upgradePlan({});
                      toggle();
                    }}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ConfirmPaymentModal;
